import { createReducer } from '@reduxjs/toolkit';
import { statisticsLogStreamingInit } from './init';
import {
  requestStatisticsLog,
  requestStatisticsLogFailure,
  requestStatisticsLogSuccess,
} from 'redux/actions/statisticsLog/actions';

const statisticsLog = createReducer(statisticsLogStreamingInit, {
  [requestStatisticsLog.type]: (state, action: RequestStatisticsLogAction) => {
    state.isLoading = true;
  },
  [requestStatisticsLogSuccess.type]: (state, action: RequestStatisticsLogSuccessAction) => {
    const { streamingCount } = action.payload;
    state.isLoading = false;
    state.streamingCount = streamingCount;
  },
  [requestStatisticsLogFailure.type]: (state, action: RequestStatisticsLogFailureAction) => {
    state.isLoading = false;
  },
});

export default statisticsLog;
